export default "__VITE_ASSET__Dqan6fCE__"